import { useTranslation } from "react-i18next";

export default function EmptyState() {
    const { t } = useTranslation();

    return (
        <div className="h-full w-full flex items-center justify-center text-gray-500 dark:text-gray-400">

            {t("roomchat.empty_state")}

        </div>
    )

}